var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pt-integral-goods-review',{ref:"table",staticClass:"pt-integral-goods-review__withData",on:{"approvalReject":_vm.approvalReject,"offTheShelf":_vm.offTheShelf}})}
var staticRenderFns = []

export { render, staticRenderFns }